import { useDomTracking } from '@nrdy-marketing-engine/tracking';

/**
 * A low-intent "Back" button, typically placed at the bottom of the panel to take the user
 * to the previous form step, or to exit the form entirely.
 */
function BackButton({ onClick, text = 'Back' }) {
  const clickTrackable = useDomTracking('click');

  return (
    <div className="mt-8">
      <button
        className="flex items-center text-primary group"
        onClick={onClick}
        ref={clickTrackable}
      >
        <svg
          className="transition-transform group-hover:-translate-x-1"
          fill="currentColor"
          height="24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 0h24v24H0z" fill="none" />
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
        </svg>
        <span className="mt-[1px] ml-1">{text}</span>
      </button>
    </div>
  );
}

export default BackButton;
